export const dictionary = {
    common: {
        ui: {
            menu: {
                main: {
                    sections: {
                        sensors: "Sensors",
                        observations: "Observations",
                        modelling: "Modelling",
                        mapFeatures: "Map features",
                        output: "Export & Report",
                        setUp: "Set up",
                    },
                },
            },
        },
    },
    temporalUnits: {
        millis: { long: { singular: 'millisecond', plural: 'milliseconds' }, short: { singular: 'ms', plural: 'ms' } },
        seconds: { long: { singular: 'second', plural: 'seconds' }, short: { singular: 'sec.', plural: 'sec.' } },
        minutes: { long: { singular: 'minute', plural: 'minutes' }, short: { singular: 'min.', plural: 'min.' } },
        hours: { long: { singular: 'hour', plural: 'hours' }, short: { singular: 'hr.', plural: 'hrs.' } },
        days: { long: { singular: 'day', plural: 'days' }, short: { singular: 'day', plural: 'days' } },
        weeks: { long: { singular: 'week', plural: 'weeks' }, short: { singular: 'wk.', plural: 'wks.' } },
        months: { long: { singular: 'month', plural: 'months' }, short: { singular: 'mon.', plural: 'mon.' } },
        quarters: { long: { singular: 'quarter', plural: 'quarters' }, short: { singular: 'qtr.', plural: 'qtrs.' } },
        years: { long: { singular: 'year', plural: 'years' }, short: { singular: 'yr.', plural: 'yrs.' } },
    },
    timezone: "Timezone",
    custom: 'custom',
    period: 'period',
};
